import { DefaultLayout } from 'core/layouts';
import {
  DetailsEditSaveButton,
  EditableHeader,
  EditorContentContainer,
  LayoutContentContainer,
  SettingsAndCreatorWrapper,
  SettingsContainer,
  SettingsCreatorAndModifierSection,
  SettingsHeader,
  SettingsLoader,
  SettingsWrapper,
  getMediumDataContentId,
} from '../common';
import { displayContent } from '../common/content';
import { ErrorWarningBanner } from '../common/ErrorWarningBanner';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { useQueryParamContext } from '../context/QueryParamContext';
import { useTemplateQueryContext } from '../context/TemplateQueryContext';
import { useLocaleSwitchLoader } from '../hooks/useLocaleSwitchLoader';
import { PreviewPane } from './preview/PreviewPane';
import { SettingsForm } from './SettingsForm';

export const TEMPLATE_EDITOR_PUSH_SETTINGS_TEST_ID = 'template-editor-push-settings';

export const SettingsEditorCore = () => {
  const { isJourneyAssociated } = useQueryParamContext();
  const { isLoading } = useLocaleSwitchLoader();
  const { medium } = useTemplateQueryContext();
  const { isEditMode, liveTemplate } = useEditableFieldsContext();
  const contentId = getMediumDataContentId(medium, liveTemplate);

  return (
    <EditorContentContainer>
      <SettingsAndCreatorWrapper>
        <SettingsContainer
          data-test={TEMPLATE_EDITOR_PUSH_SETTINGS_TEST_ID}
          isEditMode={isEditMode}
        >
          <SettingsWrapper>
            <SettingsHeader>
              {displayContent.headerDetails}
              <DetailsEditSaveButton />
            </SettingsHeader>
            {!isJourneyAssociated && <ErrorWarningBanner />}
            <SettingsForm key={contentId} />
          </SettingsWrapper>
          {isLoading && <SettingsLoader isLoading={true} />}
        </SettingsContainer>
        <SettingsCreatorAndModifierSection />
      </SettingsAndCreatorWrapper>
      <PreviewPane />
    </EditorContentContainer>
  );
};

export const Settings = () => (
  <DefaultLayout>
    <LayoutContentContainer>
      <EditableHeader />
      <SettingsEditorCore />
    </LayoutContentContainer>
  </DefaultLayout>
);

export default Settings;
